export enum SectionOrientation {
  FrontBack = 'front-back',
  BackFront = 'back-front',
  LeftRight = 'left-right',
  RightLeft = 'right-left',
}
